import { ChangePasswordComponent } from './change-password.component';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';

export const ChangePassword = connect((state: AppState) => ({ sState: state }))(
  ChangePasswordComponent as any
) as unknown as typeof ChangePasswordComponent;
